var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.203,
    height: 19.742,
    viewBox: "0 0 28.203 19.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "motorcycle",
    d: "M15.093,32a1.751,1.751,0,0,1,1.547.925l.621,1.144,2.089-1.741a1.413,1.413,0,0,1,.9-.327h.9a1.409,1.409,0,0,1,1.41,1.41v1.41a1.409,1.409,0,0,1-1.41,1.41H18.429l2.428,4.455a7.142,7.142,0,0,1,1.705-.225A5.641,5.641,0,1,1,16.922,46.1,5.578,5.578,0,0,1,19,41.73l-.679-1.26A6.93,6.93,0,0,0,15.511,46.1a7.357,7.357,0,0,0,.141,1.41h-3.1a7.285,7.285,0,0,0,.1-1.41A7.024,7.024,0,0,0,5.6,39.051H1.37v-1.41a1.436,1.436,0,0,1,1.41-1.41H7.293a2.811,2.811,0,0,1,1.992.824l1.957,2,4.363-3.6-.723-1.335H12.3A1.058,1.058,0,1,1,12.3,32Zm4.649,14.1a2.82,2.82,0,1,0,2.82-2.82,2.436,2.436,0,0,0-.313.018l1.243,2.3a1.057,1.057,0,0,1-1.86,1L20.39,44.3a2.806,2.806,0,0,0-.648,1.8Zm-8.558,1.058a5.641,5.641,0,1,1,0-2.115H8.254a2.82,2.82,0,1,0,0,2.115ZM4.23,46.1a1.41,1.41,0,1,1,1.41,1.41A1.409,1.409,0,0,1,4.23,46.1Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/motor.2a659b0a58f8ae4308f28295d017fac8.svg";
export { ForwardRef as ReactComponent };